module.exports = __webpack_public_path__ + "img/getcode-1.1449864e.png";